import React from 'react';
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '../../../js/AppState';

import Texts from 'react-sdk/Texts';
import './PopupReglesTirage.css';

const PopupReglesTirage = () => {

  console.log("PopupReglesTirage")

  function handleClose() {
    PopupsManager.close(POPUPS.REGLES_TIRAGE)
  }

  return (
    <div className="PopupReglesTirage" >        
        <div className="Popup" >
          <div className="Popup-close" onClick={() => handleClose() }><p>&times;</p></div>
          <div className="content" >
            <h2><div dangerouslySetInnerHTML={{__html: Texts.get("regles-tirage-title")}}></div></h2>
            <div className="text" dangerouslySetInnerHTML={{__html: Texts.get("regles-tirage-text")}} />
        </div>
      </div>
    </div>
  );
};

export default PopupReglesTirage;
